/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function StreamlinedPayment(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="4" width="72" height="72" rx="28" fill="white" />
      <rect
        x="4"
        y="4"
        width="72"
        height="72"
        rx="28"
        fill="url(#paint0_radial_streamlined_payment)"
        fillOpacity="0.25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.666 30.6055C46.666 29.6622 45.7133 29.0172 44.8375 29.3675L34.9226 33.3335H46.666V30.6055ZM26.666 35.5695V36.0002V44.0001V50.6668C26.666 52.1396 27.8599 53.3335 29.3327 53.3335H50.666C52.1388 53.3335 53.3327 52.1396 53.3327 50.6668V36.0002C53.3327 34.5274 52.1388 33.3335 50.666 33.3335H49.3327V30.6055C49.3327 27.7756 46.4746 25.8406 43.8471 26.8916L28.3423 33.0935C27.3299 33.4985 26.666 34.479 26.666 35.5695ZM45.3327 40.0002V46.6668H47.9993V40.0002H45.3327Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.666 30.6055C46.666 29.6622 45.7133 29.0172 44.8375 29.3675L34.9226 33.3335H46.666V30.6055ZM26.666 35.5695V36.0002V44.0001V50.6668C26.666 52.1396 27.8599 53.3335 29.3327 53.3335H50.666C52.1388 53.3335 53.3327 52.1396 53.3327 50.6668V36.0002C53.3327 34.5274 52.1388 33.3335 50.666 33.3335H49.3327V30.6055C49.3327 27.7756 46.4746 25.8406 43.8471 26.8916L28.3423 33.0935C27.3299 33.4985 26.666 34.479 26.666 35.5695ZM45.3327 40.0002V46.6668H47.9993V40.0002H45.3327Z"
        fill="url(#paint1_radial_streamlined_payment)"
        fillOpacity="0.5"
      />
      <defs>
        <radialGradient
          id="paint0_radial_streamlined_payment"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4 -30) rotate(65.7416) scale(127.783 61.2153)"
        >
          <stop stopColor="#19BCC9" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_streamlined_payment"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.0128 30.7784) rotate(43.0295) scale(56.069 26.8648)"
        >
          <stop stopColor="#19BCC9" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
      </defs>
    </svg>
  )
}

StreamlinedPayment.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default StreamlinedPayment
